var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { t } from '@lingui/core/macro';
import { useToast } from '@pocketlaw/tetris';
import { useUpdateContact } from './useUpdateContact';
import { ContactForm } from '../ContactForm';
export function UpdateContact(props) {
    const { data, onClose } = props;
    const { addToast } = useToast();
    const { id } = data, initialValues = __rest(data, ["id"]);
    const { updateContact, rejections } = useUpdateContact({
        onCompleted: () => {
            addToast({
                title: t({
                    message: 'Contact updated',
                    comment: 'Contact library - Contact updated toast',
                }),
                appearance: 'success',
            });
            onClose();
        },
        onError: () => {
            addToast({
                title: t({
                    message: 'Failed to update contact',
                    comment: 'Contact library - Unknown API error when updating contact',
                }),
                appearance: 'danger',
            });
        },
    });
    return (<ContactForm initialValues={initialValues} rejections={rejections} onClose={onClose} onSubmit={(values) => updateContact(id, values)}/>);
}
